import { TabsRoot, TabsList, TabsTrigger, TabsContent } from './Tabs';

export const Tabs = {
	Root: TabsRoot,
	List: TabsList,
	Trigger: TabsTrigger,
	Content: TabsContent
};
